export const USER_PERMISSION_FLEET_ADMIN_READONLY = "fleet_admin.read_only";
export const USER_PERMISSION_FLEET_ADMIN = "fleet_admin";
export const USER_PERMISSION_SUPER_ADMIN = "super_admin";
export const USER_PERMISSION_ADMIN = "fleet_admin";
